// extracted by mini-css-extract-plugin
module.exports = {"nav":"navigation_nav__1f96-","stickyResponsive":"navigation_stickyResponsive__1khxt"};